<template>
	<div class="pt-5">
		<div v-for="(block, i) in userInfo" :key="i">
			<ShortProfileCard
				v-if="block.block_name === 'shortProfile'"
				:profile="block.block_data"
				@toggleToPublicInfo="toggleToPublicInfo"
				:isPublicButton="isPublicButton"
			/>
			<NoteBlock
				v-else-if="block.block_name === 'noteBlock'"
				:note="block.block_data.note"
				@edit="switchNoteFormModal"
			/>
			<FieldsBlock
				v-else-if="block.block_name === 'blockFields'"
				:title="block.block_title"
				:fields="block.block_data"
			/>
		</div>
	</div>
</template>
<script>
import ShortProfileCard from '@/components/User/ShortProfileCard.vue'
import linkifyThreadText from '@/mixins/linkifyThreadText'
import NoteBlock from '@/components/User/NoteBlock.vue'
import FieldsBlock from '@/components/User/FieldsBlock.vue'

export default {
	name: 'UserInfo',
	components: { ShortProfileCard, FieldsBlock, NoteBlock },
	mixins: [linkifyThreadText],
	data() {
		return {
			isCollapsed: true,
			isShowAllButtonVisible: false,
		}
	},
	props: {
		userInfo: {
			type: Array,
			default: () => [],
		},
		isPublicButton: {
			type: Boolean,
			default: false,
		},
		isNoteSection: {
			type: Boolean,
			default: false,
		},
		follow_note: {
			type: String,
			default: '',
		},
	},
	methods: {
		switchNoteFormModal() {
			return this.$emit('switchNoteFormModal')
		},
		toggleToPublicInfo() {
			return this.$emit('toggleToPublicInfo')
		},
	},
}
</script>

<style lang="scss">
.personal-profile {
	background-color: transparent !important;
	&__section {
		max-width: 555px;
		border-radius: 8px !important;
		margin-bottom: 8px;
		border: 1px solid #e2e2e2 !important;
		padding: 12px;
		background-color: #ffffff !important;
		box-shadow: none !important;
		&__title {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a;
		}
		&__bio {
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 16px;
			line-height: 140%;
			letter-spacing: 0;
			color: #4a4a4a;
			margin-top: 12px;
		}
		&__wrapper {
			display: flex;
			flex-direction: column;
			gap: 8px;
			&__info {
				display: flex;
				flex-direction: column;
				gap: 8px;
				border-radius: 8px;
				&__field-title {
					font-family: 'Inter', sans-serif;
					font-weight: 700;
					font-size: 16px;
					line-height: 100%;
					letter-spacing: 0;
					color: #4a4a4a;
				}
				&__value-link {
					font-family: 'Inter', sans-serif;
					font-weight: 400;
					font-size: 16px;
					line-height: 140%;
					letter-spacing: 0;
					cursor: pointer;
					color: var(--primary_color);
				}
				&__value {
					font-family: 'Inter', sans-serif;
					font-weight: 400;
					font-size: 16px;
					line-height: 140%;
					letter-spacing: 0;
					color: #4a4a4a;
				}
			}
		}
		&__note-button {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			color: var(--primary_color);
		}
	}
	&__public-button {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		gap: 8px;
		&__label {
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--primary_color);
		}
	}
}
</style>
